export const formatPercentage = (number: number, precision = 0): string => {
  return formatWithPrecision(number * 100, precision) + '%';
};

export const formatWithSuffix = (number: number, precision = 1): string => {
  const absNumber = Math.abs(number);
  let suffix = '';
  let shortNumber = number;

  if (absNumber >= 1e9) {
    suffix = 'B';
    shortNumber = number / 1e9;
  } else if (absNumber >= 1e6) {
    suffix = 'M';
    shortNumber = number / 1e6;
  } else if (absNumber >= 1e3) {
    suffix = 'K';
    shortNumber = number / 1e3;
  }

  return `${formatWithPrecision(shortNumber, precision)}${suffix}`;
};

export const formatWithSuffixWithMinimum = (number: number, precision = 1, min = 5000): string =>
  Math.abs(number) < min ? `< ${min}` : formatWithSuffix(number, precision);

export const formatWithPrecision = (number: number, precision = 0): string => {
  return parseFloat(number.toFixed(precision)).toString();
};

export const formatWithCommas = (number: number): string => {
  return new Intl.NumberFormat('en-US').format(number);
};

const COMPACT_FORMAT_THRESHOLD = 1e4;

export const formatCompactNumber = (value: number, compactThreshold = COMPACT_FORMAT_THRESHOLD): string => {
  return Math.abs(value) >= compactThreshold ? formatWithSuffix(value) : formatWithCommas(value);
};
